import React from 'react';
import useReveal from '../../../shared/hooks/useReveal';

const industries = [
  {
    title: 'Restaurants & Hospitality',
    description: 'Sync your POS, payroll, and inventory. Know your food cost in real time, not at month-end.',
  },
  {
    title: 'Retail & E-Commerce',
    description: 'Unify online and in-store data. Track inventory velocity and fulfillment from a single view.',
  },
  {
    title: 'Professional Services',
    description: 'Connect project management, billing, and utilization. Understand profitability by client or team.',
  },
  {
    title: 'Enterprise Operations',
    description: 'Multi-location, multi-system, multi-team. Complexity for the org, simplicity for the people.',
  },
];

const Industries = () => {
  const [headerRef, headerVisible] = useReveal();
  const [cardsRef, cardsVisible] = useReveal({ threshold: 0.05 });

  return (
    <section id="industries" className="py-28 md:py-40 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section number */}
        <div ref={headerRef}>
          <div className={`flex items-center gap-6 mb-16 reveal from-left ${headerVisible ? 'visible' : ''}`}>
            <span className="text-6xl md:text-8xl font-extralight text-zinc-100">03</span>
            <div className="h-px flex-1 bg-zinc-100" />
          </div>

          <div className="max-w-2xl mb-20">
            <h2 className={`text-3xl md:text-[2.75rem] font-light text-zinc-900 leading-tight mb-6 reveal from-below ${headerVisible ? 'visible' : ''}`}
                style={{ transitionDelay: '0.15s' }}>
              From your neighborhood restaurant to the Fortune 500.
            </h2>
            <p className={`text-zinc-500 text-base md:text-lg leading-relaxed reveal from-below ${headerVisible ? 'visible' : ''}`}
               style={{ transitionDelay: '0.3s' }}>
              If your business runs on more than guesswork, it belongs on{' '}
              <span className="text-shine font-medium">Arbcor</span>.
            </p>
          </div>
        </div>

        {/* Industry cards - horizontal strips, not boxes */}
        <div ref={cardsRef} className="stagger">
          {industries.map((industry, i) => (
            <div
              key={i}
              className={`reveal from-below group flex flex-col md:flex-row md:items-center gap-4 md:gap-12 py-10 border-t border-zinc-100 cursor-default ${cardsVisible ? 'visible' : ''}`}
            >
              <span className="text-xs text-zinc-300 tracking-wider md:w-12 flex-shrink-0">
                0{i + 1}
              </span>
              <h3 className="text-xl md:text-2xl font-light text-zinc-900 md:w-80 flex-shrink-0 group-hover:translate-x-2 transition-transform duration-500">
                {industry.title}
              </h3>
              <p className="text-zinc-500 text-base leading-relaxed md:max-w-md">
                {industry.description}
              </p>
            </div>
          ))}
          <div className="border-t border-zinc-100" />
        </div>

        {/* Reinforcement */}
        <div className={`mt-16 reveal from-below ${cardsVisible ? 'visible' : ''}`}
             style={{ transitionDelay: '0.6s' }}>
          <p className="text-zinc-400 text-sm">
            Don't see your industry?{' '}
            <a
              href="mailto:contact@arbcor.com"
              className="text-zinc-600 underline hover:text-zinc-900 transition-colors"
            >
              Talk to us
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Industries;
